export const structuredClone = <T>(val: T): T => {
    if (!("structuredClone" in globalThis)) {
        // Structured Clone is supported in nearly all browsers released since early 2022, however some people never update their browsers.
        // This is a basic polyfill that we had previously defined in jest config, as our tests sometimes run in older node versions.
        return JSON.parse(JSON.stringify(val));
    } else {
        return globalThis.structuredClone(val);
    }
};
